/**
 * Object of user roles
 */
export default {
  ORDER_DELIVERY: 'ORDER_DELIVERY',
  BUYER_APPOINTMENT: 'BUYER_APPOINTMENT',
  BLOCK: 'BLOCK',
};
